import queryString from "query-string";
import { api } from "../../Lib/constants";
import { getAuthHeader } from "../../Lib/utils";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  INVOICES,
  INVOICES_SUCCESS,
  INVOICES_FAILED,
  TAXLIST,
  TAXLIST_SUCCESS,
  TAXLIST_FAILED,
  INVOICEID,
  INVOICEID_SUCCESS,
  INVOICEID_FAILED,
  ADDINVOICE,
  ADDINVOICE_SUCCESS,
  ADDINVOICE_FAILED,
  UPDATEINVOICE,
  UPDATEINVOICE_SUCCESS,
  UPDATEINVOICE_FAILED,
  DELETEINVOICE,
  DELETEINVOICE_SUCCESS,
  DELETEINVOICE_FAILED,
  VIEWINVOICE,
  VIEWINVOICE_SUCCESS,
  VIEWINVOICE_FAILED,
  UPDATESTATUS,
  UPDATESTATUS_SUCCESS,
  UPDATESTATUS_FAILED,
  INVOICESLIST,
  INVOICESLIST_SUCCESS,
  INVOICESLIST_FAILED,
  CURRENCY_LIST,
  CURRENCY_LIST_SUCCESS,
  CURRENCY_LIST_FAILED,
  SYSTEM_SETTINGS,
  SYSTEM_SETTINGS_SUCCESS,
  SYSTEM_SETTINGS_FAILED
} from "./actionTypes";

export const getInvoices = (params) => async (dispatch) => {
  const param = queryString.parse(params);
  dispatch({
    type: INVOICES,
  });
  try {
    let response = await api(
      `invoices/searched${params}`,
      "get",
      {},
      getAuthHeader()
    );
    console.log("invoices data", response);
    dispatch({
      type: INVOICES_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("fetching invoices error ====>>>", error);
    return dispatch({
      type: INVOICES_FAILED,
      payload: error?.message,
    });
  }
};
export const getInvoicesList = () => async (dispatch) => {
  dispatch({
    type: INVOICESLIST,
  });
  try {
    let response = await api(`invoices/list`, "get", {}, getAuthHeader());
    console.log("invoiceslist data", response);
    dispatch({
      type: INVOICESLIST_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching invoice List error ====>", error);
    toast.error(`Error : ${error.message}`);
    return Promise.reject(
      dispatch({
        type: INVOICESLIST_FAILED,
        payload: error?.message,
      })
    );
  }
};
export const getCurrencyList = () => async (dispatch) => {
  dispatch({
    type: CURRENCY_LIST,
  });
  try {
    let response = await api(`invoices/currencyList`, "get", {}, getAuthHeader());
    console.log("currencylist data", response);
    dispatch({
      type: CURRENCY_LIST_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching currency List error ====>", error);
    toast.error(`Error : ${error.message}`);
    return Promise.reject(
      dispatch({
        type: CURRENCY_LIST_FAILED,
        payload: error?.message,
      })
    );
  }
};
export const getInvoiceId = () => async (dispatch) => {
  dispatch({
    type: INVOICEID,
  });
  try {
    console.log("running getInvoiceId function");
    const response = await api(
      "invoices/lastinvoiceid",
      "get",
      {},
      getAuthHeader()
    );
    console.log(response);
    dispatch({
      type: INVOICEID_SUCCESS,
      payload: response?.data?.id,
    });
    return response;
  } catch (error) {
    console.log("while fetching invoiceId error ====>", error);
    toast.error(`Error : ${error.message}`);
    return Promise.reject(
      dispatch({
        type: INVOICEID_FAILED,
        payload: error?.message,
      })
    );
  }
};
export const getTaxesList = () => async (dispatch) => {
  dispatch({
    type: TAXLIST,
  });
  try {
    console.log("running getTaxesList function");
    const response = await api(
      "invoices/taxeslist",
      "get",
      {},
      getAuthHeader()
    );
    dispatch({
      type: TAXLIST_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log(error);
    toast.error(`Error : ${error.message}`);
    return Promise.reject(
      dispatch({
        type: TAXLIST_FAILED,
        payload: error?.message,
      })
    );
  }
};
export const addInvoice = (invoice) => async (dispatch) => {
  dispatch({
    type: ADDINVOICE,
  });
  try {
    const response = await api(
      "invoices/add",
      "post",
      invoice,
      getAuthHeader()
    );
    response && toast.success("Added Successfully");
    console.log("addinvoice success response is ===>", response);
    dispatch({
      type: ADDINVOICE_SUCCESS,
      payload: response?.invoice,
    });
    return response;

  } catch (error) {
    console.log("adding invoice error is ===> ", error);
    toast.error(`Error : ${error.message}`);
    return Promise.reject(
      dispatch({
        type: ADDINVOICE_FAILED,
        payload: error?.message,
      })
    );
  }
};
export const updateInvoice = (invoice, id) => async (dispatch) => {
  dispatch({
    type: UPDATEINVOICE,
  });
  try {
    const response = await api(
      `invoices/update/${id}`,
      "put",
      invoice,
      getAuthHeader()
    );
    response && toast.success("Updated Successfully");
    console.log("updatinginvoice success, rersponse is ===>", response);
    dispatch({
      type: UPDATEINVOICE_SUCCESS,
      payload: response?.invoice,
    });
    return response;
  } catch (error) {
    console.log("updating invoice, error is ===>", error);
    toast.error(`Error : ${error.message}`);
    return Promise.reject(
      dispatch({
        type: UPDATEINVOICE_FAILED,
        payload: error?.message,
      })
    );
  }
};
export const deleteInvoices = (ids) => async (dispatch) => {
  dispatch({
    type: DELETEINVOICE,
  });
  try {
    const response = await api(
      `invoices/delete`,
      "delete",
      { ids },
      getAuthHeader()
    );
    response && toast.success("Deleted Successfully");
    dispatch({
      type: DELETEINVOICE_SUCCESS,
      payload: response?.data,
    });
    return response?.data;
  } catch (error) {
    console.log("Error: while deleting Invoice, error is ====>", error.message);
    toast.error(`Error : ${error.message}`);
    return Promise.reject(
      dispatch({
        type: DELETEINVOICE_FAILED,
        payload: error?.message,
      })
    );
  }
};
export const getSingleInvoice = (ids) => async (dispatch) => {
  dispatch({
    type: VIEWINVOICE,
  });
  try {
    const response = await api(
      `invoices/invoice/${ids}`,
      "get",
      {},
      getAuthHeader()
    );
    dispatch({
      type: VIEWINVOICE_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("Error: while Fetching Single Invoice, error is ====>", error);
    return Promise.reject(
      dispatch({
        type: VIEWINVOICE_FAILED,
        payload: error?.message,
      })
    );
  }
};
export const updateInvoiceStatus = (id, status) => async (dispatch) => {
  dispatch({
    type: UPDATESTATUS,
  });
  try {
    const response = await api(
      `invoices/updateStatus/${id}`,
      "put",
      { status },
      getAuthHeader()
    );
    console.log(response, "<==== This is Response");
    dispatch({
      type: UPDATESTATUS_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("Error: while Updating Status, error is ====>", error);
    toast.error(`Error : ${error.message}`);
    return Promise.reject(
      dispatch({
        type: UPDATESTATUS_FAILED,
        payload: error?.message,
      })
    );
  }
};
export const getSystemSettings = () => async (dispatch) => {
  dispatch({
    type: SYSTEM_SETTINGS,
  });
  try {
    let response = await api(`invoices/systemSettings`, "get", {}, getAuthHeader());
    console.log("SystemSettings data", response);
    dispatch({
      type: SYSTEM_SETTINGS_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching SystemSettings error ====>", error);
    toast.error(`Error : ${error.message}`);
    return Promise.reject(
      dispatch({
        type: SYSTEM_SETTINGS_FAILED,
        payload: error?.message,
      })
    );
  }
};